
import { authorizedRepresentativeTypes } from '../../constants/ssap/hhmTypes/authorizedRepresentativeTypes.ts';
import { previousDataActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    applyingForFinancialAssistanceIndicator: false,
    authorizedRepresentative: {
        name: {
            firstName: null,
            middleName: null,
            lastName: null,
            suffix: null
        }
    },
    emergencyContactInfo: {
        name: {
            firstName: null,
            middleName: null,
            lastName: null,
            suffix: null
        }
    },
    getHelpIndicator: authorizedRepresentativeTypes.UNSPECIFIED,
    taxHousehold: {
        bloodRelationship: [],
        householdMember: []
    }
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case previousDataActionTypes.SET_PREVIOUS_DATA:
            return action.data;
        case previousDataActionTypes.CLEAR_PREVIOUS_DATA:
        case previousDataActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectIfPreviousDataLoaded = state => !!state.ssapApplicationId;